/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Orders_NewInputs */

const vi_report_orders_new = /** @type {(inputs: Report_Orders_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mới`)
};

/**

* @param {Report_Orders_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_orders_new = /** @type {((inputs?: Report_Orders_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Orders_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_orders_new(inputs)
});